import { FC } from 'react';

import styles from './ShowThreadButton.module.css';

export type Props = {
  openThread: (e: any) => void;
};

export const ShowThreadButton: FC<Props> = ({ openThread }) => {
  return (
    <div className={styles.gsThreadButton}>
      <p onClick={(e) => openThread(e)}>Thread Reply</p>
    </div>
  );
};
